// extracted by mini-css-extract-plugin
module.exports = {"loadingOverlay":"privateRoute_loadingOverlay__1Yjft"};